<template>
  <span class="text-h4">
    <slot />
  </span>
</template>
